// ------------------------------------------
// 選択した項目のURLへ移動するセレクト（施工事例の絞り込み）
// ------------------------------------------
class WorksLinkSelect {
  constructor(el, opt) {
    document.querySelectorAll('.' + el).forEach((select) => {
      select.addEventListener('change', () => {
        if (select.value) window.location.href = select.value;
      });
    });
  }
}
